import { useQuery } from "@tanstack/react-query";
import { getMissingHoursSummary } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Provee el resumen de horas faltantes del colaborador.
export const useMissingHours = () =>
  useQuery({
    queryKey: timeEntryKeys.missingHours(),
    queryFn: getMissingHoursSummary,
  });
